import moment from 'moment-timezone';
import Location from '@solvhealth/types/interfaces/Location';

export class UniqueYears {
  private shownYears: Set<number>;
  constructor() {
    this.shownYears = new Set<number>();
  }

  shouldShowYear(bookingYear: number) {
    if (this.shownYears.has(bookingYear)) {
      return false;
    }

    this.shownYears.add(bookingYear);
    return true;
  }
}

export const getBookingYear = (booking: any) => {
  return moment(booking.appointment_date).year();
};

export const getShowBooking = (booking: any, locations: { [id: string]: Location }) => {
  return locations[booking?.location_id];
};

enum VisitState {
  LOADING,
  EMPTY,
  VIEWING,
}

export const getVisitState = (loading: boolean, appointments: any[]) => {
  if (loading) {
    return VisitState.LOADING;
  }
  if ((appointments?.length ?? 0) < 1) {
    return VisitState.EMPTY;
  }

  return VisitState.VIEWING;
};

interface IsState {
  (visitState: VisitState): boolean;
}

export const isLoading: IsState = (s) => s === VisitState.LOADING;
export const isEmptyState: IsState = (s) => s === VisitState.EMPTY;
export const isViewing: IsState = (s) => s === VisitState.VIEWING;
